<template>
    <div id="homeBox">
        <div class="flexcenter" id="flexcenter">
            <el-button type="text" style="height: 2.5rem"  icon="el-icon-plus"  @click="add">新增</el-button>
            <div style="margin-right: 20px">
                <span>仓库:</span>
                <el-select
                        size="mini"
                        style="width: 200px ; margin-right:10px;margin-left: 5px"
                        clearable class="input-width"
                        @change="ckchange"
                        v-model="ckid"
                        filterable>
                    <el-option
                            v-for="item in ckdata"
                            :key="item.warehouseId"
                            :label="item.warehouseName"
                            :value="item.warehouseId">
                    </el-option>
                </el-select>
                <el-input
                        size="mini"
                        style="width: 200px  "
                        placeholder="请输入搜索内容"
                        v-model="searchData"
                        clearable>
                </el-input>
                <el-button  class="mrl15 " icon="el-icon-search" circle  @click="Search" size="mini"></el-button>
            </div>
        </div>
        <el-table
                id="eltable"
                ref="deliverlight"
                :height="tableHeight"
                highlight-current-row
                size="mini"
                :data="tableData"
                border
                style="width: 100%;">
            <el-table-column
                    prop="row"
                    type="index"
                    :label="$t('form_serial_number')"
                    width="70px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="khName"
                    :label="$t('form_warehouse')"
                    width="200px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="库区名称"
                    width="200px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="mj"
                    width="150px"
                    label="面积(m²)"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="rl"
                    width="150px"
                    label="容量(t)"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="note"
                    :label="$t('form_notes')"

                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    width="200px"
                    label="发布时间"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="lruName"
                    width="150px"
                    label="录入人名字"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="state"
                    label="状态"
                    width="60"
                    show-oveflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.state==1">启用</span>
                    <span v-if="scope.row.state==0">未启用</span>
                </template>
            </el-table-column>

            <el-table-column
                    width="200px"
                    label="操作">
                <template slot-scope="scope" >
                    <div >
                        <el-button  type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
                        <el-button style="color:red;"  type="text" size="mini" @click="del(scope.row)">删除</el-button>
                    </div>

                </template>
            </el-table-column>
        </el-table>
        <!--        分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother  fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10, 20, 30, 40]"

                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :pager-count="5"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">

                    </el-pagination>
                </div>

            </div>
        </div>
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                top="30px"
                width="520px"
                height="300"
                :title="title"
                :visible.sync="bianjipingtai"
                v-if="bianjipingtai"
        >
            <revise-area :ckid="ckid" :title="title" @ckidchange="ckidchange"  :ckdata="ckdata" :editData1="editData" @close="close" @getList="getList" ></revise-area>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="delDialogVisible"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="delDialogVisible"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">
                {{deltitle}}
            </div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="delDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="submitdel">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
    import {baseerp} from "@/utils/baseUrl";
    import * as API from "./api";
    import {mapActions} from "vuex";
    import reviseArea from "./component/reviseReservoirArea";

    export default{
        name:'reservoir',
        components:{
            reviseArea,
        },

        data(){
            return{
                ckid:'',
                ckdata:{},
                editData:{},
                bianjipingtai:false,//编辑弹框
                searchData:'',//搜索内容
                currentPage:1,
                pageSize:10,
                total:0,
                baseerp:'',
                tableData:[],
                tableHeight:0,//列表高度
                title:'',
                delDialogVisible:false,//删除弹框
                deltitle:'',
                timeStamp:'',
                validateKey:'',
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted(){
            this.selectWarehouse(),
            this.$nextTick(()=>{
                this.onResize();
            })
            //公共样式
            this.baseerp=baseerp
        },
        beforeDestroy() {
            // window.removeEventListener('resize',this.heightAuto)
        },
        methods:{
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80
            },
            ...mapActions(["getCurrentMenuId"]),
            //高度
            heightAuto(){
                this.tableHeight = window.innerHeight - document.getElementById('body').getBoundingClientRect().top -48 -36    ;
            },
            ckchange(val){
                this.ckid=val
                this.ckdata.warehouseId=val
            },
            ckidchange(val){
                this.ckid=val
            },
            //关闭弹框
            close(){
                this.bianjipingtai=false
            },
            //页面搜索
            Search(){
                this.getList()
                this.currentPage=1
            },
            //分页
            handleSizeChange(val) {
                this.pageSize = val;    //动态改变
                this.getList()
            },
            handleCurrentChange(val) {
                this.currentPage = val;    //动态改变
                this.getList()
            },
            //库区列表
            async getList(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    khid:this.ckid,
                    search:this.searchData,
                }
                let res = await API.getList(params);
                if (res.code == 1) {
                    this.tableData=res.data
                    this.total=res.total
                    this.tableData.forEach(item=>{
                        item.createTime=item.createTime.substring(0,19)
                    })
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //仓库下拉
            async selectWarehouse(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id) {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params={
                }
                let res = await API.selectWarehouse(params);
                if (res.code == 1) {
                    this.ckdata = res.data

                    let arr =  res.data;
                    this.ckid=arr[0].warehouseId
                    this.getList()
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //作废验证
            async beforeRemove() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                }
                let res = await API.beforeRemove(params);
                if (res.code == 1) {
                    this.deltitle=res.message
                    this.getList()
                }else {
                    this.$message.error(res.message);
                }
            },
            // 业务配置作废
            async remove() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                }
                let res = await API.remove(params);
                if (res.code == 1) {
                    this.getList()
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);

                } else {
                    this.deltitle=res.message
                }
            },
            add(){
                this.title='新增'
                this.editData={
                    id:0,
                    name:'',
                    mj:0,
                    rl:0,
                    khid:this.ckid,
                    notes:'',
                    createTime:'',
                    lruName:sessionStorage.getItem('lruname'),
                    state:1
                }
                this.bianjipingtai=true
            },
            //编辑
             edit(val){
                this.title='编辑'
                this.editData.id=val.id
                // this.getDetails()
                this.bianjipingtai=true
            },
            //确认作废
            submitdel(){
                this.remove()
                this.delDialogVisible=false
                this.getList()
            },
            //作废
            del(val){
                this.editData=val
                this.beforeRemove()
                this.delDialogVisible=true
            },
        },
    }

</script>
<style lang="scss" scoped>
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width: 53.571rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 42.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }
</style>